import { render, staticRenderFns } from "./linkageOperatorTab.vue?vue&type=template&id=2c884c4f&lang=pug"
import script from "./linkageOperatorTab.vue?vue&type=script&lang=js"
export * from "./linkageOperatorTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports